module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = react
// module chunks = 2